module.exports = __webpack_public_path__ + "img/eggs-bg.6f8b453d.jpg";